import type {VendorsPromotions} from './types';

import {Loading} from '@ds/components';
import {PageLayout} from '@ds/layout';
import {useEffect, useMemo} from 'react';
import {useAppDispatch, useAppSelector} from 'store';
import {getVendorsPromotions} from 'store/slices/promotion-center/thunk';
import {getSelectedVendorFromStorage} from 'utils/Helper';

import PromotionToolsGrid from './components/PromotionToolsGrid/PromotionToolsGrid';
import {PROMOTION_TOOLS} from './constants';

const PromotionCenter: React.FC = () => {
  const dispatch = useAppDispatch();
  const selectedVendor = getSelectedVendorFromStorage();
  const vendorId =
    typeof selectedVendor?.id === 'string' || typeof selectedVendor?.id === 'number'
      ? selectedVendor.id
      : '0';
  const {vendorsPromotions, loading} = useAppSelector((state) => state.promotionCenter);
  const promotionsData = vendorsPromotions as VendorsPromotions | null;

  useEffect(() => {
    void dispatch(getVendorsPromotions({vendor_id: vendorId}));
  }, [dispatch, vendorId]);

  const enabledTools = useMemo(
    () => PROMOTION_TOOLS.filter((tool) => promotionsData?.[tool.id]?.enabled),
    [promotionsData]
  );

  if (loading) {
    return (
      <div className="flex min-h-60 flex-1 items-center justify-center">
        <Loading size="large" color="primary" />
      </div>
    );
  }

  return (
    <PageLayout>
      <PromotionToolsGrid tools={enabledTools} />
    </PageLayout>
  );
};

export default PromotionCenter;
